/**
 * Taxonomy Selectors
 */

import { find, invert } from 'lodash';

export enum TaxonomyType {
  Tags = 'Product_tag',
  Moods = 'Mood',
  Genres = 'Genre',
  Vocals = 'Vocals',
  Languages = 'Language',
  Catalogs = 'Catalog',
  Budget = 'Budget',
  Lyrics = 'Lyric',
  Instruments = 'Instrument',
  Industries = 'Industry',
  References = 'Reference',
  ProductType = 'Product_type',
  FeMood = 'Fe_mood',
  Tempos = 'Tempo',
  RecordingCountry = 'Recording Country',
}

export const TaxonomyId = {
  [TaxonomyType.Lyrics]: 9,
};

export const TaxonomyIdToTaxonomyType: {[id: number]: TaxonomyType} = invert(TaxonomyId) as any;

interface ITaxonomyTitleOverride {
  original: TaxonomyType;
  override: string;
}

const taxonomyTitles: ITaxonomyTitleOverride[] = [
  { original: TaxonomyType.Tags, override: 'Tags' },
  { original: TaxonomyType.Genres, override: 'Genres' },
  { original: TaxonomyType.Moods, override: 'Moods' },
  { original: TaxonomyType.Languages, override: 'Languages' },
  { original: TaxonomyType.Catalogs, override: 'Catalogs' },
  { original: TaxonomyType.Industries, override: 'Industries' },
  { original: TaxonomyType.Lyrics, override: 'Lyrics' },
  { original: TaxonomyType.Instruments, override: 'Instruments' },
  { original: TaxonomyType.References, override: 'References' },
];

export function getTaxonomyTitle(original: TaxonomyType) {
  const found = find(taxonomyTitles, { original });
  return found ? found.override : original;
}

export function getTermsByTaxonomy(taxonomyType: TaxonomyType, terms: GQL.ITaxonomyTerm[]) {
  return terms.filter(({ taxonomy }) => taxonomy && taxonomy.name! === taxonomyType);
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectors/taxonomy.ts